import {
	ActionIcon,
	Box,
	Flex,
	Image,
	Tooltip,
} from '@mantine/core';
import classes from './PictureUpload.module.css';

import AvatarImage from '@assets/images/eskimo.png';
import { Button, Text } from '@components/v2/ui';
import { FileButton } from '@mantine/core';
import useStore from '@store/index';
import {
	IconDownload,
	IconTrash,
} from '@tabler/icons-react';
import { truncate } from 'lodash';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

export const PictureUpload = (props: {
	onUpload: (formData: FormData | null) => void;
	src?: string;
}) => {
	const { t } = useTranslation();
	const [file, setFile] = useState<File | null>(null);
	const [preview, setPreview] = useState<string | null>(
		null
	);
	const resetRef = useRef<() => void>(null);
	const { getUser } = useStore();
	const user = getUser();

	const handleFileChange = (
		selectedFile: File | null
	) => {
		setFile(selectedFile);
		const formData = new FormData();
		formData.append('route', 'users');
		formData.append('document', user?.id || '');
		if (selectedFile)
			formData.append('file', selectedFile);

		if (selectedFile) {
			const objectUrl = URL.createObjectURL(selectedFile);
			setPreview(objectUrl);
		} else {
			setPreview(null);
		}

		props.onUpload(formData);
	};

	const handleDelete = () => {
		setFile(null);
		setPreview(null);
		resetRef.current?.();
		props.onUpload(null);
	};

	useEffect(() => {
		if (props.src) {
			setPreview(props.src);
		}
	}, [props.src]);

	return (
		<Box className={classes.rowPicture}>
			<Box className={classes.previewPicture}>
				{preview ? (
					<Image
						src={preview}
						className={classes.avatar}
						fallbackSrc={AvatarImage}
					/>
				) : (
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="101"
						height="101"
						viewBox="0 0 101 101"
						fill="none"
					>
						<circle
							cx="50.5"
							cy="50.5"
							r="50.5"
							fill="#F0F3F8"
						/>
						<path
							d="M63 41H58.566L55.566 36H46.434L43.434 41H39C37.9391 41 36.9217 41.4214 36.1716 42.1716C35.4214 42.9217 35 43.9391 35 45V61C35 62.0609 35.4214 63.0783 36.1716 63.8284C36.9217 64.5786 37.9391 65 39 65H63C64.0609 65 65.0783 64.5786 65.8284 63.8284C66.5786 63.0783 67 62.0609 67 61V45C67 43.9391 66.5786 42.9217 65.8284 42.1716C65.0783 41.4214 64.0609 41 63 41ZM51 60C49.6155 60 48.2622 59.5895 47.111 58.8203C45.9599 58.0511 45.0627 56.9579 44.5328 55.6788C44.003 54.3997 43.8644 52.9922 44.1345 51.6344C44.4046 50.2765 45.0713 49.0292 46.0503 48.0503C47.0292 47.0713 48.2765 46.4046 49.6344 46.1345C50.9922 45.8644 52.3997 46.003 53.6788 46.5328C54.9579 47.0627 56.0511 47.9599 56.8203 49.111C57.5895 50.2622 58 51.6155 58 53C58 54.8565 57.2625 56.637 55.9497 57.9497C54.637 59.2625 52.8565 60 51 60Z"
							fill="#97AAC1"
						/>
					</svg>
				)}
				<Flex
					direction="column"
					align="flex-start"
					justify="center"
				>
					<Tooltip
						label={file?.name}
						disabled={
							!!(
								file &&
								file.name &&
								file?.name?.length <= 30
							) || !file
						}
					>
						<Box>
							<Text variant="subtitle1" c={'#1D3965'}>
								{file && file.name
									? truncate(file.name, {
											length: 30,
										})
									: t('global.logo')}
							</Text>
						</Box>
					</Tooltip>
					<Text variant="body2" c={'#727272'}>
						{t('global.infoUploadPicture')}
					</Text>
				</Flex>
			</Box>
			<Box className={classes.actionsPicture}>
				<FileButton
					resetRef={resetRef}
					onChange={handleFileChange}
					accept="image/png,image/jpeg"
				>
					{(props) => (
						<Button
							size="xs"
							variant="primary"
							leftSection={
								<IconDownload
									style={{
										width: '24px',
										height: '24px',
									}}
									stroke={1.5}
									color="#D2E0F4"
								/>
							}
							{...props}
						>
							{t('global.uploadNewPicture')}
						</Button>
					)}
				</FileButton>

				<ActionIcon
					radius={'25px'}
					variant="outline"
					color="#ADD2EA"
					h={'48px'}
					w={'48px'}
					onClick={handleDelete}
				>
					<IconTrash
						style={{ width: '24px', height: '24px' }}
						stroke={1.5}
						color="#727272"
					/>
				</ActionIcon>
			</Box>
		</Box>
	);
};
